import { Encoder, Utils } from '@everyboard/lib';
import { Move } from '../../jscaip/Move';
export class P4Move extends Move {
    x;
    static encoder = Encoder.tuple([Encoder.identity()], (move) => [move.x], (value) => P4Move.of(value[0]));
    static of(x) {
        Utils.assert(0 <= x, 'P4Move should be a positive integer!');
        return new P4Move(x);
    }
    constructor(x) {
        super();
        this.x = x;
    }
    equals(other) {
        return this.x === other.x;
    }
    toString() {
        return 'P4Move(' + this.x + ')';
    }
}
